import React, { Component } from 'react';
import Toggle               from 'material-ui/Toggle';

class GeoToggle extends Component
{
    handleToggle = () =>
    {
        if (this.props.geo.available)
        {
            if (this.props.geo.watching)
            {
                this.props.geoStopWatching();
            }
            else
            {
                this.props.geoStartWatching();
            }
        }

        this.props.geoResetInformed();
    };


    render = () => {
        return (
        <Toggle
            className="center-y"
            label="GPS"
            thumbStyle={ { backgroundColor: this.props.theme.accent } }
            trackStyle={ { backgroundColor: this.props.theme.text } }
            labelStyle={ { color: this.props.theme.text } }
            thumbSwitchedStyle={{ backgroundColor: this.props.theme.accentTwo }}
            trackSwitchedStyle={ { backgroundColor: this.props.theme.text } }
            onToggle={ this.handleToggle.bind(this) }
            toggled={ this.props.geo.watching }
        />);
    }

}

export default GeoToggle;



// WEBPACK FOOTER //
// ./src/components/Banner/GeoToggle.js